<template>
    <div>
        <v-toolbar color="indigo" dark>
            <!-- <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon> -->
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-progress-circular v-if="progressBar"
                                 indeterminate
                                 color="white"
            ></v-progress-circular>
            <!-- <v-btn icon @click="$router.push({path: '/dashboard'})">
                <v-icon>dashboard</v-icon>
            </v-btn>
            <v-btn icon>
                <v-icon>account_box</v-icon>
            </v-btn> -->
        </v-toolbar>
        <SnackBar/>
    </div>
</template>

<script>
    import SnackBar from './SnackBar'

    export default {
        name: 'Toolbar',
        components: {SnackBar},
        props: ['title'],
        data: () => ({}),
        computed: {
            drawer: {
                get() {
                    return this.$store.state.drawer
                }, set(value) {
                    this.$store.commit('setDrawer', value)
                }
            },
            progressBar: {
                get() {
                    return this.$store.state.progressBar
                },
                set(value) {
                    this.$store.state.progressBar = value
                }
            }
        },
        methods: {}
    }
</script>

<style scoped>

</style>
